import React from "react";

export default function NojoomPointsHistoryShimmer() {
  const styles={
    icon:{
      width: '40px',
      height: '40px',
      margin: 0
    },
    width40:{
      width: '40%',
      direction: 'ltr'
    }
  }
  const Cards = ()=>{
    return(
      <>
      <div className="d-flex justify-content-between align-items-center">
      <div className="twocoloum_txt_restrct">
        <div>
        <h6 className="regular_14 shimmerBG w-25"></h6>
        </div>
        <p className=" mb-0 support_text_grey_12 mb-0 shimmer-h15 shimmerBG" style={styles.width40}>
          
        </p>
      </div>
      <div className="mb-0 support_text_grey_12 shimmerBG shimmer-h15 width-20">
      </div>
      <div className="ar-tick-icon">
      <div
        className="pointer shimmer-icon-xs shimmerBG mb-0"
      />
      </div>
      
    </div>
    <hr/>
    </>
    )
  }
  return (
    <div className="">
    
      <div className=" mb-5">
        {[1,2,3,4,5].map(item=>(<Cards/>))}
      </div>
    </div>
  );
}
